import { useContext } from "preact/hooks";
import SettingsContext from "../SettingsContext";
import { ParsedSettings } from "../../types/settings";
import { LOCAL_HOST, PRODUCTION_HOST } from "../../constants/hosts";

type Route =
  | "/"
  | "/transcript"
  | "/audio_description"
  | "/metadata"
  | "/source";

export type Value = string | number;
export type Params = Record<string, Value | Value[] | undefined>;

function buildParams(data: Params) {
  const queryString: string[] = [];

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((value) => queryString.push(`${key}[]=${value}`));
    } else if (value) {
      queryString.push(`${key}=${value}`);
    }
  });

  return queryString.join("&");
}

export function recordedEndpoint(
  settings: ParsedSettings,
  route: Route,
  params: Params = {}
): URL {
  const queryString = buildParams({
    access_id: settings.accessId,
    platform: settings.platform,
    threeplay_id: settings.threeplayId,
    media_id: settings.mediaId,
    playback: settings.playback,
    ...params,
  });

  const host = settings.apiHost === "local" ? LOCAL_HOST : PRODUCTION_HOST;
  return new URL(`${host}/v1/recorded${route}?${queryString}`);
}

export function useRecordedURL(route: Route, params: Params = {}): URL {
  const { settings } = useContext(SettingsContext);

  return recordedEndpoint(settings, route, params);
}
